import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonEn from '../locales/en/common.json';
import authEn from '../locales/en/auth.json';
import commonEs from '../locales/es/common.json';
import authEs from '../locales/es/auth.json';

i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        resources: {
            en: {
                common: commonEn,
                auth: authEn,
            },
            es: {
                common: commonEs,
                auth: authEs,
            },
        },
        fallbackLng: 'en',
        ns: ['common', 'auth'],
        defaultNS: 'common',
        interpolation: {
            escapeValue: false,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
        },
    });

export default i18n;
